// src\pages\Blog\BlogPage.tsx

export const BlogPage = () => {
  return (
    <div>BlogPage</div>
  )
}

export default BlogPage